import React from "react";
import "./App.css";
import { Toaster } from "sonner";
import { Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { HomePage } from "./pages/HomePage";
import { ConteudoPage } from "./pages/ConteudoPage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { RequireAdminSession } from "./components/RequireAdminSession";

function App() {
  const location = useLocation();
  const hideSiteChrome = location.pathname.startsWith("/admin");

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      {!hideSiteChrome && <WhatsAppFloat />}
      {!hideSiteChrome && <Header />}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/conteudo" element={<ConteudoPage />} />
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route
          path="/admin/dashboard"
          element={(
            <RequireAdminSession>
              <AdminDashboardPage />
            </RequireAdminSession>
          )}
        />
      </Routes>

      {!hideSiteChrome && <Footer />}
    </div>
  );
}

export default App;
